export class InsecureServerAuth {
    pairingId;
    role;
    constructor(pairingId, role) {
        this.pairingId = pairingId;
        this.role = role;
    }
    async generateToken() {
        const tokenStructure = {
            pairingId: this.pairingId,
            role: this.role,
            expiry: Number.MAX_SAFE_INTEGER
        };
        return JSON.stringify(tokenStructure);
    }
}
